// Multi-seleção com checkboxes (dropdown) — filtros componíveis, ex.: Unilever + Arcor.
import { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown, X } from 'lucide-react';

interface Opcao {
  id: number;
  nome: string;
}

interface Props {
  rotulo: string;
  opcoes: Opcao[];
  selecionados: number[];
  onChange: (ids: number[]) => void;
}

export default function MultiSelect({ rotulo, opcoes, selecionados, onChange }: Props) {
  const [aberto, setAberto] = useState(false);
  const [filtro, setFiltro] = useState('');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!aberto) return;
    const fecha = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setAberto(false);
    };
    document.addEventListener('click', fecha);
    return () => document.removeEventListener('click', fecha);
  }, [aberto]);

  const toggle = (id: number) => {
    onChange(selecionados.includes(id) ? selecionados.filter((s) => s !== id) : [...selecionados, id]);
  };

  const visiveis = opcoes.filter((o) => !filtro || o.nome.toLowerCase().includes(filtro.toLowerCase()));

  return (
    <div className="relative" ref={ref}>
      <button type="button" className={`btn secondary ${selecionados.length ? '!border-accent !text-accent' : ''}`} onClick={() => setAberto((a) => !a)}>
        {rotulo}{selecionados.length > 0 && ` (${selecionados.length})`} <ChevronDown size={14} />
      </button>
      {aberto && (
        <div className="multi-pop">
          <input
            autoFocus
            placeholder={`Filtrar ${rotulo.toLowerCase()}…`}
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          <div className="multi-lista">
            {visiveis.map((o) => {
              const on = selecionados.includes(o.id);
              return (
                <button key={o.id} type="button" className={on ? 'on' : ''} onClick={() => toggle(o.id)}>
                  <span className="check">{on && <Check size={12} />}</span>
                  {o.nome}
                </button>
              );
            })}
            {visiveis.length === 0 && <p className="empty !py-4">Nada encontrado.</p>}
          </div>
          {selecionados.length > 0 && (
            <button type="button" className="multi-limpar" onClick={() => onChange([])}>
              <X size={12} /> Limpar seleção
            </button>
          )}
        </div>
      )}
    </div>
  );
}
